export const LIGHTPRESSUREMIN = 1
export const LIGHTPRESSUREMED = 20
export const LIGHTPRESSUREMAX = 35
export const MEDPRESSUREMIN = 36
export const MEDPRESSUREMED = 80
export const MEDPRESSUREMAX = 89
export const DEEPPRESSUREMIN = 90
export const DEEPPRESSUREMED = 115
export const DEEPPRESSUREMAX = 127
